export default {"src":"/_next/static/media/icon-data-empowered.9552fa32.svg","height":141,"width":141,"blurWidth":0,"blurHeight":0};